/** @format */

import React, { useEffect } from "react";
import { useAppSelector } from "./Components/Global/Store";
import ConsultRoutes from "./Components/Routes/ConsultDashRoutes";
import DashBoardRoute from "./Components/Routes/DashBoardRoute";
import HomeRoutes from "./Components/Routes/HomeRoutes";
import { PrivateRoute } from "./Components/Routes/private/PrivateRoute";
import { useNavigate } from "react-router-dom";

function App() {
  return (
    <>
      <HomeRoutes />
      <PrivateRoute>
        <DashBoardRoute />
      </PrivateRoute>
      {/* <div>
        {typeof consultant?.name === "string" ? <ConsultRoutes /> : null}
      </div> */}
    </>
  );
  // route
}

export default App;
